import { render, staticRenderFns } from "./shopCommunity.vue?vue&type=template&id=1b1eb9d0&scoped=true"
import script from "./shopCommunity.vue?vue&type=script&lang=js"
export * from "./shopCommunity.vue?vue&type=script&lang=js"
import style0 from "./shopCommunity.vue?vue&type=style&index=0&id=1b1eb9d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1eb9d0",
  null
  
)

export default component.exports